/** Download / import helpers for league builder templates and league rules profiles. */

export function downloadBlob(filename, content, mime = 'text/plain;charset=utf-8') {
  const safeName = String(filename || 'download').replace(/[/\\?%*:|"<>]/g, '-');
  const blob = new Blob([content], { type: mime });

  if (typeof navigator !== 'undefined' && typeof navigator.msSaveOrOpenBlob === 'function') {
    navigator.msSaveOrOpenBlob(blob, safeName);
    return;
  }

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = safeName;
  a.rel = 'noopener';
  a.style.position = 'fixed';
  a.style.left = '-9999px';
  a.style.top = '0';
  document.body.appendChild(a);
  a.click();
  window.setTimeout(() => {
    a.remove();
    URL.revokeObjectURL(url);
  }, 250);
}

export function sanitizeExportBasename(name, fallback = 'export') {
  const base = String(name || fallback)
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .slice(0, 60);
  return base || fallback;
}

export function pickTextFile(accept = '.json,.txt,application/json,text/plain') {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) {
        resolve(null);
        return;
      }
      const reader = new FileReader();
      reader.onload = () => resolve({ file, text: String(reader.result || '') });
      reader.onerror = () => resolve(null);
      reader.readAsText(file);
    };
    input.click();
  });
}

const JSON_MARKER = '--- DATA (JSON) ---';

export function parseImportDocument(text, expectedKind) {
  const raw = String(text || '').trim();
  if (!raw) throw new Error('File is empty');
  let jsonStr = raw;
  const idx = raw.indexOf(JSON_MARKER);
  if (idx >= 0) {
    jsonStr = raw.slice(idx + JSON_MARKER.length).trim();
  } else if (!raw.startsWith('{') && !raw.startsWith('[')) {
    throw new Error(
      'This text file has no import data. Use a .json export or a .txt file that includes the JSON data block.',
    );
  }
  let doc;
  try {
    doc = JSON.parse(jsonStr);
  } catch {
    throw new Error('Could not parse JSON in import file');
  }
  if (expectedKind && doc.kind !== expectedKind) {
    throw new Error(`Expected a ${expectedKind} file (found ${doc.kind || 'unknown type'})`);
  }
  return doc;
}

export function wrapExportDocument(kind, payload) {
  return {
    kind,
    version: 1,
    exportedAt: new Date().toISOString(),
    ...payload,
  };
}

export function textExportWithJsonSection(title, summaryLines, doc) {
  return [
    title,
    `Exported: ${new Date().toLocaleString()}`,
    '',
    ...summaryLines,
    '',
    JSON_MARKER,
    JSON.stringify(doc, null, 2),
  ].join('\n');
}
